import React from "react";
import { Link } from "react-router-dom";

function UserConfirmation() {
  return (
    <div className="container text-center py-5 min-vh-100">
      <div className="row d-flex justify-content-center align-items-center h-100">
        <div className="col-10 col-md-8 col-lg-6 col-xl-5 log">
          <div
            className="card  mt-5"
            style={{ maxWidth: "48rem", backgroundColor: "#38E54D" }}
          >
            <div className="card-header" style={{ border: "none" }}>
              <i className="fa-solid fa-circle-check fa-4x"></i>
            </div>
            <div className="card-body">
              <h3 className="card-text">
                Thank You!
                <p className="text-danger font_header mt-1">
                  Please Check your email for Reset Password
                </p>
              </h3>
              <Link className="btn btn-dark mx-auto px-4 ms-2" to="/">
                OK
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UserConfirmation;
